<template>
  <div class="Dialog error" v-if="isShown">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>
      <div class="icon-close" @click="send('CLOSE')"></div>
      <div class="title"><span>温馨提示</span></div>

      <div class="inner-body">
        <p class="content">
          {{getAggregatingMeta.message}}</p>
        <div class="btns">
          <button class="btn" @click="send('CLOSE')">{{getAggregatingMeta.btnText || "确定"}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
export default {
  name: "ErrorPage",
  props: ["state", "send"],
  setup(props) {
    const isShown = computed(() => {
      return ["participate.pay.preCheck.unusedCoupon", "participate.luckydraw.batchDraw.receiveTaskOrGetCouponError"].some(
        props.state.matches
      )
    })

    const mergeMeta = meta => {
      return Object.keys(meta).reduce((acc, key) => {
        const value = meta[key]

        // Assuming each meta value is an object
        Object.assign(acc, value)

        return acc
      }, {})
    }
    const getAggregatingMeta = computed(() => {
      return mergeMeta(props.state.meta)
    })

    return {
      isShown,
      getAggregatingMeta
    }
  }
}
</script>

<style scoped>
</style>
